export default function PublicLayout({ children }: React.PropsWithChildren<{}>) {

    return (
        <div className="container-fluid">
            {children}
        </div>
    );
}